import React, { useState,useEffect,useRef } from 'react';

import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import '../lib/bootstrap.min.css'
import './Main.css';
import './SubPage.css';

const Home = (props) => {
    const [title,setTitle] = useState()
    const [greeting,setGreeting] = useState()
    const [background,setBackground] = useState()
    const [wifiSSID,setWifiSSID] = useState()
    const [wifiPassword,setWifiPassword] = useState()
    
    useEffect(()=>{
        if(props.profile){ 
//            console.log(props.profile)
            setTitle(props.profile.filter((_profile)=> _profile.object === 'title')[0].value)
            setGreeting(props.profile.filter((_profile)=> _profile.object === 'greeting')[0].value)
            
            setWifiSSID(props.profile.filter((_profile)=> _profile.object === 'wifi_ssid')[0].value)
            setWifiPassword(props.profile.filter((_profile)=> _profile.object === 'wifi_password')[0].value)
        }
    })
    

  return (
    <AnimatePresence>
        <Row>
            <Col md={9}>
                <motion.div 
                    className='content-left'
                    initial={{ opacity: 0, marginLeft:-300 }}
                    animate={{ opacity: 1, marginLeft: 0,  }}
                    exit={{opacity:0, marginLeft: -300}}
                    transition={{ duration: 0.8, ease: [0.7, 0, 0.3, 1] }}
                >
                    <h2 style={{fontSize:40}}>{title},</h2>
                    <p style={{fontSize:18, lineHeight:1.5, minHeight:90}}>{greeting} </p>
                    <button className="btnHome" style={{float:'right'}} onClick={()=>{props.propertyInfo()}}>
                        Hotel Information &raquo;
                    </button>
                </motion.div>
            </Col>
            <Col md={3}>
                <motion.div className='content-right'
                    initial={{ opacity: 0, marginRight:-300 }}
                    animate={{ opacity: 1, marginRight: 0,  }}
                    exit={{opacity:0, marginRight:-300}}
                    transition={{ duration: 0.8, ease: [0.87, 0, 0.13, 1] }}>
                        <div style={{marginTop:'60px', textAlign: 'center', width:200, float:'right'}}>
                            &nbsp;
                            <p>Scan QR Code <br />to connect WIFI</p>
                            {/*<img src={props.content.wifi_qrcode} width={100} />
                            <br /><br />
                            <button className='btnHome'>Help ?</button>*/}
                        </div>
                    
                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )};

export default Home;


